import { Injectable, signal } from '@angular/core';
import { ModalsService } from 'app/shared/ui/modals/modals.service';

declare let Intercom: {
    booted?: boolean;
    (method: string, ...args: any[]): void;
};


@Injectable({
    providedIn: 'root',
})
export class SupportService {

    cmaLearnMoreRebgvCourseLink = signal('');

    cmaLearnMorePhone = signal('');

    cmaHelpCentreLink = 'https://help.autoprop.ca/en/articles/6882829-autoprop-cma-report-price-adjustments';

    constructor(private modalsService: ModalsService) {}

    openSupport(message = 'Hello, ') {
        if (typeof Intercom === 'undefined' || !Intercom.booted) {
            this.modalsService.alert(
                `Please e-mail us at <a href="mailto:support@autoprop.ca">support@autoprop.ca</a>. Thank you.`,
                'Please, Contact our Support'
            );
            return;
        }
        Intercom('showNewMessage', message);
    }

    feedbackForApplication() {
        if (typeof Intercom === 'undefined' || !Intercom.booted) {
            this.modalsService.alert(
                `Is there something missing or did something not work? ` +
                `Please e-mail us at <a href="mailto:support@autoprop.ca">support@autoprop.ca</a>. Thank you.`,
                'Please, Leave us Feedback'
            );
            return;
        }
        Intercom('showNewMessage', 'Hello, I have trouble with ');
    }

    feedbackForDataSource(name: string) {
        if (typeof Intercom === 'undefined' || !Intercom.booted) {
            this.modalsService.alert(
                `Is there something missing or did something not work? ` +
                `Please e-mail us at <a href="mailto:support@autoprop.ca">support@autoprop.ca</a>. Thank you.`,
                'Please, Leave us Feedback'
            );
            return;
        }
        Intercom('showNewMessage', `Hello, I have trouble with ${name} `);
    }
}
